$('#LoginForm').on('submit', function (event) {

  event.preventDefault();

  $.ajax({
    type: 'POST',
    url: '/Authentication/Process',
    data: $('#LoginForm').serialize(),    

    beforeSend: function (xhr) {

      if(!$('#LoginForm').parsley().isValid()){
        return false;
      }

      /* Hide Form */
      $('#LoginForm').hide();

      /* Show loader */
      $(".Loader").show();

    },

    success: function (data) {

      /* Redirect to Verify */
      window.location.replace(data);

    },

    error: function (Response) {

      var data = JSON.parse(Response.responseText);

      new Noty({
        type: 'Error',
        entity: data.Entity,
        text: data.Message,
        callbacks: {
          afterShow: function () {
            location.reload()
          },
        }
      }).show();
    }
  });
});

$('#VerifyAuthenticationForm').on('submit', function (event) {

  event.preventDefault();

  $.ajax({
    type: 'POST',
    url: '/Authentication/Verify',
    data: $('#VerifyAuthenticationForm').serialize(),
    dataType: 'JSON',

    beforeSend: function () {

      if (!$('#VerifyAuthenticationForm').parsley().isValid()) {
        return false;
      }

      /* Hide Form */
      $('#VerifyAuthenticationForm').hide();

      /* Show loader */
      $(".Loader").show();

    },

    success: function (data) {

      /* Redirect to Two Factor */
      window.location.replace(data.Redirect);
    },

    error: function (Response) {

      var data = JSON.parse(Response.responseText);

      /* Hide loader */
      $(".Loader").hide();

      /* Show Form */
      $('#VerifyAuthenticationForm').show();

      new Noty({
        type: 'Error',
        entity: data.Entity,
        text: data.Message
      }).show();

    }
  });
});

/**
 * Resend Verify Code
 */
$(document).on('click', '#ResendAuthenticationVerifcationCode', function () {

  event.preventDefault();
  var ID = $(this).data("id");

  bootbox.confirm({
    title: "<i class='ion-md-mail'></i> Code opnieuw versturen?",
    message: "Weet je zeker dat je de code opnieuw wilt genereren en versturen?",
    backdrop: true,
    buttons: {
      confirm: {
        label: '<i class="ion-md-send"></i> Opnieuw versturen',
        className: "btn btn-main"
      }
    },

    callback: function (result) {
      if (result === true) {
        $.ajax({
          type: 'POST',
          url: '/Authentication/Verify/Resend'
        });
      }
    }
  });
});